import React from 'react';
import { Link } from 'react-router-dom';
import isMobile from 'is-mobile';
import accounting from 'accounting';

import { formatHTML } from '../utils';


function headerClassName(costo){
  if(costo+""==="0") {
    return "card course free-course";
  } else {
    return "card course";
  }
}

function renderFooter(alumno, curso){
  if(alumno===undefined || alumno===null || alumno.id===undefined){
    return (
      <span className="control-section">
        <h4><span className="badge badge-success float-left">{curso.costo!=="0" ? accounting.formatMoney(curso.costo, "Gs", 0, ".") : "Gratis!!"}</span></h4>
        <button className="btn btn-primary">Saber Más</button>
      </span>
    );
  } else {
    let costo = accounting.formatMoney(curso.costo, "Gs", 0, ".");
    let mensaje = "Saber Más";
    if(alumno.cursosDisponibles.indexOf(curso.id) >= 0){
      costo = "Adquirido";
      mensaje = "Entrar";
    } else if(costo+""==="0") {
      costo = "Gratis!!";
    }
    return (
      <span className="control-section">
        <h4><span className="badge badge-success float-left">{costo}</span></h4>
        <button className="btn btn-primary">{mensaje}</button>
      </span>
    );
  }
}

export default function(props){
  let curso = props.curso;
  let alumno = props.alumno;
  return (
    <div className={`col-sm-${isMobile() ? "12" : "4"}`} key={curso.id}>
      <Link to={`/curso/${curso.id}`} className={headerClassName(curso.costo)}>
        <img className="card-img-top" src={window.location.hostname==="localhost" ? "https://aulas.ceis.com.py"+curso.img : curso.img} alt={`Imagen del curso ${curso.titulo}`} />
        <div className="card-body">
          <h5 className="card-title">{curso.titulo}</h5>
          <p className="card-text">{formatHTML(curso.descripcion.length>150 ? curso.descripcion.substring(0, 150)+'...' : curso.descripcion)}</p>
          {renderFooter(alumno, curso)}
        </div>
      </Link>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/curso_item.js